
<template>


    <input type="password"
           v-bind:value="value"
           v-on:input="OnValueChange"
           :class="CssClass"
           :readonly="ReadOnly"
           :disabled="Enabled == false"
           :nullable="Nullable" />


</template>

<script>
    import Utility from '@/Common/Utility'

    export default {
        data() {
            return {

                m_Attribute: {
                    Nullable: false
                }
            };
        }
        ,
        props: ["value", "nullable", "Attribute"],


        computed: {

            CssClass: {

                get: function () {
                    let result = "";


                    if (this.Attribute != null && this.Attribute.CssClass != null) {
                        result = this.Attribute.CssClass;
                    }

                    return result;
                }
            }
            ,
            Nullable: function () {
                if (this.m_Attribute.Nullable == null) {
                    this.m_Attribute.Nullable = false;
                }

                return this.m_Attribute.Nullable + "";
            }
            ,

            ReadOnly: {

                get: function () {
                    let result = false;

                    if (this.m_Attribute != null && this.m_Attribute.ReadOnly != null) {
                        result = this.Attribute.ReadOnly;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            Disabled: {

                get: function () {
                    let result = false;


                    if (this.m_Attribute.Enabled != null) {
                        result = !this.m_Attribute.Enabled;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            },

            Enabled: {

                get: function () {
                    let result = true;

                    if (this.m_Attribute != null && this.m_Attribute.Enabled != null) {
                        result = this.m_Attribute.Enabled;
                    }

                    return result;
                }
            },


        }
        ,

        methods: {


            OnValueChange(e) {
                this.$emit("input", e.target.value);
            },

            UpdateElementByAttribute() {

            },

            OnButtonClick() {
                alert("Enabled = " + this.m_Attribute.Enabled);
            }

        },

        created() {

            if (this.nullable == "false") {
                this.m_Attribute.Nullable = false;
            }
            else {
                this.m_Attribute.Nullable = true;
            }

            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            }
        },

        watch: {
            Attribute: function (newVal, oldVal) {
 
                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);

                this.$forceUpdate();
            },

            nullable: function (newVal, oldVal) {
            }
        }


    }
</script>

<style>
</style>
